const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[+\d][\d\s\-().]{5,}$/;
const PINCODE_RE = /^\d{4,10}$/;

function trim(s) {
  return (s === null || s === undefined ? "" : String(s)).trim();
}

/**
 * @returns {string|null} Single message if invalid; null if step can proceed.
 */
export function validatePublicWizardStep(step, form, rows) {
  if (step === 0) {
    if (!trim(form.customerName)) return "Please enter your full name.";
    if (trim(form.customerName).length < 2) return "Name must be at least 2 characters.";
    if (!trim(form.email)) return "Please enter your email address.";
    if (!EMAIL_RE.test(trim(form.email))) return "Please enter a valid email address (e.g. you@example.com).";
    if (trim(form.phoneNumber) && !PHONE_RE.test(trim(form.phoneNumber))) {
      return "Enter a valid phone number (digits, spaces, dashes, or + prefix).";
    }
    return null;
  }
  if (step === 1) {
    if (!trim(form.originAddress1)) return "Please enter your origin address (line 1).";
    if (!trim(form.originCity)) return "Please enter the origin city.";
    if (!trim(form.originState)) return "Please enter the origin state / province.";
    if (!trim(form.originPincode)) return "Please enter the origin PIN / ZIP code.";
    if (!PINCODE_RE.test(trim(form.originPincode))) return "Origin PIN code must be 4–10 digits.";
    return null;
  }
  if (step === 2) {
    if (!trim(form.destinationAddress1)) return "Please enter your destination address (line 1).";
    if (!trim(form.destinationCity)) return "Please enter the destination city.";
    if (!trim(form.destinationState)) return "Please enter the destination state / province.";
    if (!trim(form.destinationPincode)) return "Please enter the destination PIN / ZIP code.";
    if (!PINCODE_RE.test(trim(form.destinationPincode))) return "Destination PIN code must be 4–10 digits.";
    return null;
  }
  if (step === 3) {
    const validLines = (rows || []).filter((r) => {
      const nm = trim(r.item);
      const qty = Number(r.quantity);
      return nm && Number.isFinite(qty) && qty > 0;
    });
    if (!validLines.length) {
      return "Add at least one item with a name and quantity greater than zero.";
    }
    const invalidQty = (rows || []).find((r) => {
      const nm = trim(r.item);
      const qty = Number(r.quantity);
      return nm && (!Number.isFinite(qty) || qty <= 0);
    });
    if (invalidQty) return `Quantity for "${invalidQty.item}" must be a positive number.`;
    return null;
  }
  return null;
}
